import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BreakdownTechnicianStatus, BreakdownTechnicianStatusUpdate, TechDriverLocation, DocumentCategory, UserLocation } from '../models/user';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DriverService {
  apiUrl = 'v1/driver/';

  constructor(private http: HttpClient) { }

  public getTechnicianDriverStatus(driverId: number) {
    return this.http.get<BreakdownTechnicianStatus>(`${environment.apiUrl + this.apiUrl}technician/${driverId}/status`);
  }

  public updateTechnicianDriverStatus(driverId: number, status: BreakdownTechnicianStatusUpdate) {
    return this.http.put<BreakdownTechnicianStatus>(`${environment.apiUrl + this.apiUrl}technician/${driverId}/status`, status);
  }

  public updateDriverLocation(location: UserLocation) {
    return this.http.post<{detail: string}>(`${environment.apiUrl + this.apiUrl}location`, location);
  }

  public getTechDriverLatestLocation(driverId: number) {
    return this.http.get<TechDriverLocation>(`${environment.apiUrl + this.apiUrl}${driverId}/location/latest`);
  }

  public getDocumentCategories() {
    return this.http.get<DocumentCategory[]>(`${environment.apiUrl + this.apiUrl}document/categories`);
  }


}
